import React from "react";
import { PhosphorMagicWand } from "components/Atoms/PhosphorIcon";
import { Message } from "semantic-ui-react";
import { ButtonAccent } from "components/Atoms/Button";
import { routes } from "utilities/routing/generatedRoutes";
import { NewFlightWithAIAssistantModal } from "extractorSession/new/NewFlightWithAIAssistantModal";

interface Props {
  artist: server.dto.ArtistSmall | null;
}

export const FlightAIAd = (props: Props) => {
  const [isNewFlightOpen, setIsNewFlightOpen] = React.useState(false);

  return <div className="flex-column gap padding-left padding-right padding-top padding-top-bigger padding-bottom-bigger">
    <div className="flex align-end gap">
      <div style={{ height: 24 }}><PhosphorMagicWand iconSize="large" /></div>
      <h3>Let AI handle the travel admin.</h3>
    </div>
    <Message color="purple">
      Our AI reads your PDF and automatically extracts: departure and arrival times, airports, booking numbers, seats.
    </Message>
    <div>
      <ButtonAccent label="Import flights" onClick={() => setIsNewFlightOpen(true)} />
    </div>
    <NewFlightWithAIAssistantModal
      initialArtist={props.artist}
      isOpen={isNewFlightOpen}
      onClose={() => setIsNewFlightOpen(false)}
      onUploadSuccess={() => {
        window.location.href = routes.extractorSession_list().absolute;
      }}
    />
  </div>
}